export const color = {
  terracotta: {
    default: '#C96D3A',
    '500': '#C96D3A',
    '400': '#D48A61',
    '300': '#DFA789',
    '200': '#E9C5B0',
    '100': '#F4E2D8',
  },
  moss: {
    default: '#526D61',
    '500': '#526D61',
    '400': '#758A81',
    '300': '#97A7A0',
    '200': '#BAC5C0',
    '100': '#E8E9E3',
  },
  olive: {
    default: '#8E9173',
    '500': '#8E9173',
    '400': '#A5A78F',
    '300': '#BBBDAB',
    '200': '#D2D3C7',
    '100': '#E8E9E3',
  },
  merlot: {
    default: '#741114',
    '500': '#741114',
    '400': '#904143',
    '300': '#AC7072',
    '200': '#C7A0A1',
    '100': '#E3CFD0',
  },
  cream: {
    default: '#E2DAD0',
    '500': '#E2DAD0',
    '400': '#E8E1D9',
    '300': '#EEE9E3',
    '200': '#F3F0EC',
    '100': '#F9F8F6',
  },
  charcoal: {
    default: '#161418',
    '500': '#161418',
    '400': '#454346',
    '300': '#737274',
    '200': '#A2A1A3',
    '100': '#D0D0D1',
  },
  coral: {
    default: '#CD6E61',
    '500': '#CD6E61',
    '400': '#DE978A',
    '300': '#E1A8A0',
    '200': '#EBC5C0',
    '100': '#F5E2DF',
  },
  grey: {
    default: '#E3E3E3',
    '60': '#E3E3E3',
    '40': '#ECECED',
    '20': '#F6F6F6',
    '10': '#FAFAFA',
  },
};
